export const videoReviews = [
    {
        mp4: "https://res.cloudinary.com/dirscuuhp/video/upload/q_auto/reviews/Anja_exwckw.mp4",
        hls: "https://res.cloudinary.com/dirscuuhp/video/upload/q_auto/reviews/Anja_exwckw.m3u8",
        poster: "https://res.cloudinary.com/dirscuuhp/image/upload/v1779212833/reviews/Story_t6z5zf.webp",
        name: "Anja",
    },
    {
        mp4: "https://res.cloudinary.com/dirscuuhp/video/upload/q_auto/reviews/Tiffany_F_ibbsye.mp4",
        hls: "https://res.cloudinary.com/dirscuuhp/video/upload/q_auto/reviews/Tiffany_F_ibbsye.m3u8",
        poster: "https://res.cloudinary.com/dirscuuhp/image/upload/v1778163558/reviews/story-2_helujp.webp",
        name: "Tiffany",
    },
    {
        mp4: "https://res.cloudinary.com/dirscuuhp/video/upload/q_auto/reviews/Celine_M_vxrgui.mp4",
        hls: "https://res.cloudinary.com/dirscuuhp/video/upload/q_auto/reviews/Celine_M_vxrgui.m3u8",
        poster: "https://res.cloudinary.com/dirscuuhp/image/upload/v1778163554/reviews/story-3_tvtv5b.webp",
        name: "Celine",
    },
    {
        mp4: "https://res.cloudinary.com/dirscuuhp/video/upload/q_auto/reviews/Lisa_F_wixgi5.mp4",
        hls: "https://res.cloudinary.com/dirscuuhp/video/upload/q_auto/reviews/Lisa_F_wixgi5.m3u8",
        poster: "https://res.cloudinary.com/dirscuuhp/image/upload/v1778163511/reviews/story-4_t527vv.webp",
        name: "Lisa",
    },
    {
        mp4: "https://res.cloudinary.com/dirscuuhp/video/upload/q_auto/reviews/testimony_client_testimony_4-5_v.1_k42x0v.mp4",
        hls: "https://res.cloudinary.com/dirscuuhp/video/upload/q_auto/reviews/testimony_client_testimony_4-5_v.1_k42x0v.m3u8",
        poster: "https://res.cloudinary.com/dirscuuhp/image/upload/v1778163510/reviews/story-5_cbvv0y.webp",
        name: "Tanya F",
    },
    {
        mp4: "https://res.cloudinary.com/dirscuuhp/video/upload/q_auto/reviews/testimony_client_testimony_4-5_v.4_pqvsjq.mp4",
        hls: "https://res.cloudinary.com/dirscuuhp/video/upload/q_auto/reviews/testimony_client_testimony_4-5_v.4_pqvsjq.m3u8",
        poster: "https://res.cloudinary.com/dirscuuhp/image/upload/v1778163511/reviews/story-6_msykg5.webp",
        name: "Kayla A",
    },
    {
        mp4: "https://res.cloudinary.com/dirscuuhp/video/upload/q_auto/reviews/testimony_client_testimony_4-5_v.9_uzivph.mp4",
        hls: "https://res.cloudinary.com/dirscuuhp/video/upload/q_auto/reviews/testimony_client_testimony_4-5_v.9_uzivph.m3u8",
        poster: "https://res.cloudinary.com/dirscuuhp/image/upload/v1778163507/reviews/story-7_oqfgb6.webp",
        name: "Rebecca E",
    },
    {
        mp4: "https://res.cloudinary.com/dirscuuhp/video/upload/q_auto/reviews/testimony_client_testimony_4-5_v.2_vg1bx4.mp4",
        hls: "https://res.cloudinary.com/dirscuuhp/video/upload/q_auto/reviews/testimony_client_testimony_4-5_v.2_vg1bx4.m3u8",
        poster: "https://res.cloudinary.com/dirscuuhp/image/upload/v1778163507/reviews/story-8_b1k7rf.webp",
        name: "Melanie W",
    },
    {
        mp4: "https://res.cloudinary.com/dirscuuhp/video/upload/q_auto/reviews/testimony_client_testimony_4-5_v.11_nck9db.mp4",
        hls: "https://res.cloudinary.com/dirscuuhp/video/upload/q_auto/reviews/testimony_client_testimony_4-5_v.11_nck9db.m3u8",
        poster: "https://res.cloudinary.com/dirscuuhp/image/upload/v1778163504/reviews/story-9_zgkp89.webp",
        name: "Pam K",
    },
    {
        mp4: "https://res.cloudinary.com/dirscuuhp/video/upload/q_auto/reviews/testimony_client_testimony_4-5_v.10_ty98bk.mp4",
        hls: "https://res.cloudinary.com/dirscuuhp/video/upload/q_auto/reviews/testimony_client_testimony_4-5_v.10_ty98bk.m3u8",
        poster: "https://res.cloudinary.com/dirscuuhp/image/upload/v1778163505/reviews/story-10_tb6pbw.webp",
        name: "Kristin W",
    },
    {
        mp4: "https://res.cloudinary.com/dirscuuhp/video/upload/q_auto/reviews/Brook_K_os3dzm.mp4",
        hls: "https://res.cloudinary.com/dirscuuhp/video/upload/q_auto/reviews/Brook_K_os3dzm.m3u8",
        poster: "https://res.cloudinary.com/dirscuuhp/image/upload/v1778163502/reviews/story-11_ct0bnk.webp",
        name: "Brook K",
    },
    {
        mp4: "https://res.cloudinary.com/dirscuuhp/video/upload/q_auto/reviews/testimony_client_testimony_4-5_v.3_faytl1.mp4",
        hls: "https://res.cloudinary.com/dirscuuhp/video/upload/q_auto/reviews/testimony_client_testimony_4-5_v.3_faytl1.m3u8",
        poster: "https://res.cloudinary.com/dirscuuhp/image/upload/v1778163501/reviews/story-12_i2rcah.webp",
        name: "Elizabeth C",
    },
    {
        mp4: "https://res.cloudinary.com/dirscuuhp/video/upload/q_auto/reviews/testimony_client_testimony_4-5_v.7_sqrjlf.mp4",
        hls: "https://res.cloudinary.com/dirscuuhp/video/upload/q_auto/reviews/testimony_client_testimony_4-5_v.7_sqrjlf.m3u8",
        poster: "https://res.cloudinary.com/dirscuuhp/image/upload/v1778163498/reviews/story-13_pnkwxq.webp",
        name: "Angie J",
    },
    {
        mp4: "https://res.cloudinary.com/dirscuuhp/video/upload/q_auto/reviews/Kristin_K_i0lq4d.mp4",
        hls: "https://res.cloudinary.com/dirscuuhp/video/upload/q_auto/reviews/Kristin_K_i0lq4d.m3u8",
        poster: "https://res.cloudinary.com/dirscuuhp/image/upload/v1778163496/reviews/story-14_f4ydsu.webp",
        name: "Kristin K",
    },
    {
        mp4: "https://res.cloudinary.com/dirscuuhp/video/upload/q_auto/reviews/Heather_C_omsnr4.mp4",
        hls: "https://res.cloudinary.com/dirscuuhp/video/upload/q_auto/reviews/Heather_C_omsnr4.m3u8",
        poster: "https://res.cloudinary.com/dirscuuhp/image/upload/v1778163496/reviews/story-15_z5nis2.webp",
        name: "Heather C",
    },
    {
        mp4: "https://res.cloudinary.com/dirscuuhp/video/upload/q_auto/reviews/Sheri_M_gpt8op.mp4",
        hls: "https://res.cloudinary.com/dirscuuhp/video/upload/q_auto/reviews/Sheri_M_gpt8op.m3u8",
        poster: "https://res.cloudinary.com/dirscuuhp/image/upload/v1778163495/reviews/story-16_tju2mt.webp",
        name: "Sheri M",
    },
    {
        mp4: "https://res.cloudinary.com/dirscuuhp/video/upload/q_auto/reviews/Katie_V_qjnlsd.mp4",
        hls: "https://res.cloudinary.com/dirscuuhp/video/upload/q_auto/reviews/Katie_V_qjnlsd.m3u8",
        poster: "https://res.cloudinary.com/dirscuuhp/image/upload/v1778163495/reviews/story-17_efq1ej.webp",
        name: "Katie V",
    },
    {
        mp4: "https://res.cloudinary.com/dirscuuhp/video/upload/q_auto/reviews/MaLia_T_uuvg8o.mp4",
        hls: "https://res.cloudinary.com/dirscuuhp/video/upload/q_auto/reviews/MaLia_T_uuvg8o.m3u8",
        poster: "https://res.cloudinary.com/dirscuuhp/image/upload/v1778163494/reviews/story-18_k82jow.webp",
        name: "Malia T",
    },
    {
        mp4: "https://res.cloudinary.com/dirscuuhp/video/upload/q_auto/reviews/Kathleen_F_ic2izc.mp4",
        hls: "https://res.cloudinary.com/dirscuuhp/video/upload/q_auto/reviews/Kathleen_F_ic2izc.m3u8",
        poster: "https://res.cloudinary.com/dirscuuhp/image/upload/v1778163494/reviews/story-19_m14zmm.webp",
        name: "Kathleen F",
    },
    {
        mp4: "https://res.cloudinary.com/dirscuuhp/video/upload/q_auto/reviews/testimony_client_testimony_4-5_v.6_ktvb1n.mp4",
        hls: "https://res.cloudinary.com/dirscuuhp/video/upload/q_auto/reviews/testimony_client_testimony_4-5_v.6_ktvb1n.m3u8",
        poster: "https://res.cloudinary.com/dirscuuhp/image/upload/v1778163494/reviews/story-20_nxaiib.webp",
        name: "Michelle W",
    },
    {
        mp4: "https://res.cloudinary.com/dirscuuhp/video/upload/q_auto/reviews/testimony_client_testimony_4-5_v.8_w0oeja.mp4",
        hls: "https://res.cloudinary.com/dirscuuhp/video/upload/q_auto/reviews/testimony_client_testimony_4-5_v.8_w0oeja.m3u8",
        poster: "https://res.cloudinary.com/dirscuuhp/image/upload/v1778163494/reviews/story-21_qtbfml.webp",
        name: "Martha P",
    },
];